import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/opportunities/shared/$token')({
  beforeLoad: ({ params: { token } }) => {
    throw redirect({
      to: '/issues/shared/$token',
      params: { token },
    })
  },
})
